<div class="modal-box-large">
    <div class="d-flex flex-column justify-content-start">
        <h4>Inserimento beneficiario</h4>
    </div>
    <ng-container *ngIf="subjectTypeForm && !isSimor; else simorTemplate">
        <div class="form-container">
            <app-basic-form [form]="subjectTypeForm" [keys]="filteredFormKeys"></app-basic-form>
            <ng-container *ngIf="showIndividualForm">
                <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                <app-basic-form [form]="individualForm" [keys]="individualFormKeys"></app-basic-form>
                <h6 class="card-header-label" style="padding: 1em;">Indirizzo di nascita</h6>
                <app-basic-form [form]="birthForm" [keys]="birthFormKeys"></app-basic-form>
                <h6 class="card-header-label" style="padding: 1em;">Indirizzo di residenza</h6>
                <app-basic-form [form]="residenceForm" [keys]="residenceFormKeys"></app-basic-form>
            </ng-container>
            <ng-container *ngIf="showLegalPersonForm">
                <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                <app-basic-form [form]="legalPersonForm" [keys]="legalPersonFormKeys"></app-basic-form>
                <h6 class="card-header-label" style="padding: 1em;">Indirizzo di residenza</h6>
                <app-basic-form [form]="residenceForm" [keys]="residenceFormKeys"></app-basic-form>
            </ng-container>
        </div>
    </ng-container>
    <ng-template #simorTemplate>
        <div class="modal-box-large">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="500ms" (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Nuovo beneficiario">
                    <div class="form-container">
                        <app-basic-form [form]="subjectTypeForm" [keys]="filteredFormKeys"></app-basic-form>
                        <ng-container *ngIf="showIndividualForm">
                            <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                            <app-basic-form [form]="individualForm" [keys]="individualFormKeys"></app-basic-form>
                            <h6 class="card-header-label" style="padding: 1em;">Indirizzo di nascita</h6>
                            <app-basic-form [form]="birthForm" [keys]="birthFormKeys"></app-basic-form>
                            <h6 class="card-header-label" style="padding: 1em;">Indirizzo di residenza</h6>
                            <app-basic-form [form]="residenceForm" [keys]="residenceFormKeys"></app-basic-form>
                        </ng-container>
                        <ng-container *ngIf="showLegalPersonForm">
                            <h6 class="card-header-label" style="padding: 1em;">Dati generali</h6>
                            <app-basic-form [form]="legalPersonForm" [keys]="legalPersonFormKeys"></app-basic-form>
                            <h6 class="card-header-label" style="padding: 1em;">Indirizzo di residenza</h6>
                            <app-basic-form [form]="residenceForm" [keys]="residenceFormKeys"></app-basic-form>
                        </ng-container>
                    </div>
                </mat-tab>
                <mat-tab label="Ricerca soggetto">
                    <div [ngClass]="!searchedSubject ? 'search-form-container' : 'form-container'">
                        <div class="form-container">
                            <app-basic-form [form]="searchSubjectForm" [keys]="searchSubjectFormKeys"></app-basic-form>
                            <button mat-raised-button color="primary" (click)="onSearchClick()" [disabled]="!searchSubjectForm.valid">{{'ricerca' | uppercase}}</button>
                            <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
                            <div class="mt-3" *ngIf="searchedSubject">
                                <div class="p-1 col-8">
                                    <h6 class="card-header-label" style="padding-left: 1em;">Soggetto ricercato:</h6>
                                    <app-policy-card [item]="searchedSubject" [title]="subjectName" [keys]="subjectKeys" [tooltip]="'Nuovo beneficiario'">
                                    </app-policy-card>
                                </div>
                                <div class="p-1 pt-3" *ngIf="searchedSubject && additionalSubjectInfoForm && isFiscalCodePresent">
                                    <h6 class="card-header-label" style="padding-left: 1em;">Specificare i seguenti dati:</h6>
                                    <app-basic-form [form]="additionalSubjectInfoForm" [keys]="additionalSubjectInfoFormKeys"></app-basic-form>
                                </div>
                                <div class="d-flex flex-column justify-content-start mt-2">
                                    <div class="card-disclaimer-label" *ngIf="!isFiscalCodePresent">Attenzione! Non è possibile inserire il soggetto ricercato: Codice fiscale/Partita IVA assenti</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
              </mat-tab-group>
        </div>
    </ng-template>
    <div class="d-flex justify-content-between mt-3">
        <button mat-raised-button [color]="'warn'" (click)="close()">Chiudi</button>
        <button mat-raised-button [color]="'primary'" [disabled]="isConfirmButtonDisabled" (click)="addNewBeneficiary()">Conferma</button>
    </div>
</div>
